
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/detail",
      function () {
        return require("private-next-pages/article/detail.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/detail"])
      });
    }
  